<template>
	<BaseCmsPage v-slot="{page}">
		<div class="main">
			<div class="wrapper">
				<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
				<div v-if="page?.content" v-html="page.content" v-interpolation />
			</div>
		</div>
	</BaseCmsPage>
</template>

<style lang="less" scoped>
	.main{
		padding: 50px 0;
		@media (max-width: @t){padding: 30px 0;}	
	}
	:deep(p){
		padding-bottom: 12px;
		@media (max-width: @t){padding-bottom: 10px;}	
	}
</style>